module.exports = __webpack_public_path__ + "img/product-showcase-gallery-03.0f73eaee.jpg";